import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-family__card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Product = _resolveComponent("Product")!
  const _component_Category = _resolveComponent("Category")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.type === 'Product')
      ? (_openBlock(), _createBlock(_component_Product, {
          key: 0,
          productDisplayName: $props.product?.productDisplayName,
          translations: $props.translations,
          productDetailUrl: $props.product?.productDetailUrl,
          primaryImageUrl: $props.product?.primaryImageUrl,
          isFinishImageMissing: $props.product?.isFinishImageMissing,
          portfolio: $props.product?.portfolio
        }, null, 8 /* PROPS */, ["productDisplayName", "translations", "productDetailUrl", "primaryImageUrl", "isFinishImageMissing", "portfolio"]))
      : (_openBlock(), _createBlock(_component_Category, {
          key: 1,
          displayName: $props.category?.displayName,
          imageUrl: $props.category?.imageUrl,
          productFilteringUrl: $props.category?.productFilteringUrl,
          translations: $props.translations,
          isFinishImageMissing: $props.category?.isFinishImageMissing,
          portfolio: $props.category?.portfolio
        }, null, 8 /* PROPS */, ["displayName", "imageUrl", "productFilteringUrl", "translations", "isFinishImageMissing", "portfolio"]))
  ]))
}